import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONFIGURATOR_BASE_URL } from '../app.config';
import { HomeConfig } from '../shared/home-config.model';
import { FindHomeConfigRequest } from '../shared/find-home-config.request';
import { FindHomeConfigResponse } from '../shared/find-home-config.response';

@Injectable({
    providedIn: 'root',
})
export class GetHomeConfigNameUseCase extends UseCase<FindHomeConfigRequest, Observable<HomeConfig>> {
    private _apiRequestService = inject(ApiRequestService);
    private _configuratorBaseUrl = inject<string>(CONFIGURATOR_BASE_URL);
    private _findHomeConfigUrl = '/websiteconfigurator/find-homeconfig';

    constructor(_logService: LogService, protected override _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: FindHomeConfigRequest | void): Observable<HomeConfig> | void {
        return this._apiRequestService
            .sendRequest<FindHomeConfigRequest, FindHomeConfigResponse>(
                this._configuratorBaseUrl,
                request as FindHomeConfigRequest,
                true,
                this._findHomeConfigUrl
            )
            .pipe(map((response) => response.homeConfig as HomeConfig));
    }
}
